var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "dropdown menu tender-dropdown",
      attrs: {
        id: _vm.id,
        "data-dropdown-menu": "",
        "data-disable-hover": "true",
        "data-click-open": "true",
        "data-close-on-click": "true",
      },
    },
    [
      _c("li", [
        _c("i", {
          staticClass:
            "fa fa-ellipsis-v tender-ellipsis-size mouse-over-finger",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "menu tender-ellipsis-bg",
            class: _vm.className,
            attrs: { id: "tender-ellipsis-bg-" + _vm.id },
          },
          [
            _vm._t("default", function () {
              return [
                _c("li", [
                  _c("a", [_vm._v(_vm._s(_vm.$t("addOption")))]),
                  _vm._v(" "),
                  _c("a", [_vm._v(_vm._s(_vm.$t("deleteOption")))]),
                ]),
              ]
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }